import { TextInput } from '@mantine/core';
import { useDebouncedValue } from '@mantine/hooks';
import { ItemsPerPageType, Pagination, getPagingParams } from '@uag/react-core';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useGetUserActivityLog } from 'api/v3/user/user';
import { listQueryDefault } from 'app/queryDefaults';
import { ActivityLogGrid } from './ActivityLogGrid';
import { ClientComboBox } from './ClientsComboBox';
import { addDays } from './helpers';
export const GlobalActivityLogGrid = () => {
    const [startDate, setStartDate] = useState<Date>(addDays(new Date(), -1));
    const [endDate, setEndDate] = useState<Date>(new Date());
    const [username, setUsername] = useState<string | undefined>();
    const [clientName, setClientName] = useState<string | undefined>();
    const [debounceUsername] = useDebouncedValue(username, 500);
    const { t } = useTranslation();

    const [itemsPerPage, setItemsPerPage] = useState<ItemsPerPageType>(25);
    const [page, setPage] = useState(1);

    const {
        data: activities,
        isLoading,
        error,
    } = useGetUserActivityLog(
        {
            userNameFilter: debounceUsername,
            clientNameFilter: clientName,
            start: startDate?.toISOString(),
            end: endDate?.toISOString(),
            ...getPagingParams(page, itemsPerPage),
        },
        listQueryDefault,
    );

    const totalPages = Math.ceil((activities?.metadata?.paging?.totalCount ?? 1) / itemsPerPage);

    const clientFilter = <ClientComboBox key="clientCombo" value={clientName} onChange={setClientName} />;

    const userFilter = (
        <TextInput
            key="userCombo"
            label={t('username')}
            value={username}
            w={180}
            onChange={(event) => setUsername(event.currentTarget.value)}
        />
    );

    return (
        <>
            <ActivityLogGrid
                activities={activities?.data}
                additionalFilters={[userFilter, clientFilter]}
                endDate={endDate}
                error={error}
                isLoading={isLoading}
                startDate={startDate}
                onEndDateChange={setEndDate}
                onStartDateChange={setStartDate}
            />
            <Pagination
                disabled={isLoading}
                itemsPerPage={itemsPerPage}
                page={page}
                totalPages={totalPages}
                withSkip
                onItemsPerPageChange={setItemsPerPage}
                onPageChange={setPage}
            />
        </>
    );
};
